import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../../services/api.service';
import { TranslateService } from '@ngx-translate/core';
import { ArticleDTO } from '../../../models/series.model';

@Component({
    selector: 'app-keyword-results',
    templateUrl: './keyword-results.component.html',
    styleUrls: ['./keyword-results.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class KeywordResultsComponent implements OnInit {
  keyword: string = '';
  searchType: string = 'keyword'; // 'keyword' or 'classification'
  articles: ArticleDTO[] = [];
  isLoading: boolean = true;
  error: string = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private apiService: ApiService,
    private translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.keyword = params['q'] || '';
      this.searchType = params['type'] || 'keyword'; // Varsayılan: keyword
      
      if (this.keyword) {
        this.loadArticles();
      } else {
        this.error = 'No search term provided';
        this.isLoading = false;
      }
    });
  }

  loadArticles(): void {
    this.isLoading = true;
    this.error = '';
    
    // Arama tipine göre farklı servis çağır
    const searchObservable = this.searchType === 'classification' 
      ? this.apiService.getArticlesByClassification(this.keyword)
      : this.apiService.getArticlesByKeyword(this.keyword);
    
    searchObservable.subscribe({
      next: (data) => {
        this.articles = data || [];
        this.isLoading = false;
      },
      error: (err) => {
        console.error(`Error loading articles by ${this.searchType}:`, err);
        this.error = 'Failed to load articles';
        this.isLoading = false;
      }
    });
  }

  getSearchTypeLabel(): string {
    return this.searchType === 'classification' 
      ? this.translateService.instant('CLASSIFICATION_SEARCH_TITLE')
      : this.translateService.instant('KEYWORD_SEARCH_TITLE');
  }

  getTranslatedText(value: string, removeAt: boolean = false): string {
    if (!value) return '';
    
    const text = removeAt && value.startsWith('@') ? value.substring(1) : value;
    return this.translateService.instant(text);
  }

  getFormattedAbstract(abstract: string): string {
    if (!abstract) return '';
    
    let formattedAbstract = abstract;
    
    // Limit abstract length for display
    if (formattedAbstract.length > 300) {
      formattedAbstract = formattedAbstract.substring(0, 300) + '...';
    } else {
      formattedAbstract += '...';
    }
    
    return `<div class="from-journal-content text-justify">${formattedAbstract}</div>`;
  }

  getLanguageCode(localeText: string): string {
    if (!localeText) return '';
    return localeText.split('_')[0].toUpperCase();
  }

  getArticleQueryParams(article: ArticleDTO): any {
    // Backend'den gelen ID'yi al (ID veya id property'si olabilir)
    const articleId = (article as any).ID || (article as any).id;
    
    // ID varsa queryParams olarak gönder
    return articleId ? { id: articleId } : {};
  }

  navigateToArticle(article: ArticleDTO): void {
    if (article.journalSlug && article.slug) {
      // Backend'den gelen ID'yi al (ID veya id property'si olabilir)
      const articleId = (article as any).ID || (article as any).id;
      
      // ID varsa queryParams olarak gönder
      const queryParams = articleId ? { id: articleId } : {};
      
      this.router.navigate(
        ['/journal', article.journalSlug, 'article', article.slug],
        { queryParams }
      );
    }
  }
}
